// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__3ZgbU","card":"Card_card__6G_gf","img":"Card_img__2N4kY","name":"Card_name__4RGOc","temp":"Card_temp__vTjxN","weight":"Card_weight__Cq6ua"};